import React, { useState } from "react";
import Stars from "./stars";
import CollapsibleWrapper from "../shared/collapsibleWrapper";
import { stripHtmlTags } from "../../utils/commonFunctions";

const CourseTestimonialCard = ({ reviewer, reviewDate, rating, review }) => {
  const [readMore, setReadMore] = useState(false);
  const linkName = readMore ? "Read less " : "Read more  ";
  const description = review;
  return (
    <div className="relative px-6 md:px-8 pt-12 md:pt-14 pb-11 h-full bg-yellow-lighter/80 planet:bg-white/10 planet:before:absolute planet:before:w-full planet:before:h-full planet:before:right-0 planet:before:left-0 planet:before:blur-2xl text-black-lighter planet:text-gray-generic rounded-xs before:-z-10">
      <div
        className="h3 !font-normal planet:text-gray-septenary"
        dangerouslySetInnerHTML={{ __html: reviewer }}
      />
      <div
        className="text-xs mb-4 mt-1"
        dangerouslySetInnerHTML={{ __html: reviewDate }}
      />
      <Stars
        stars={(rating / 10) * 5}
        starColorClass={{
          fill: "text-black-lighter planet:text-white",
          back: "text-transparent",
          stroke: "stroke-black-lighter planet:stroke-white"
        }}
      />
      {review && (
        <CollapsibleWrapper
          desc={description}
          summary={
            stripHtmlTags(description)?.length > 130
              ? `${stripHtmlTags(description)?.substring(0, 130)}...`
              : description
          }
          descStyle="text-section-desc-text tab-content_html"
          btnStyle="flex underline underline-offset-2 pt-2 text-generic-text font-lato planet:font-normal planet:text-white text-sm"
          wrapperContainer="text-section-desc-text tab-content_html"
          visibleLength={130}
          visibleLines={"none"}
          type={"both"}
          readMoreBtnArrowStyle="ml-1 mt-2 stroke-black-lighter planet:stroke-white transition ease-in-out duration-300"
        />
      )}
    </div>
  );
};

export default CourseTestimonialCard;
